import { SearchMode, trackEventServerSide } from "helpers/api";
import { getMajorVersion } from "helpers/services/mixpanel";
import {
  MixpanelActionSource,
  MixpanelEvent,
  NewSearchModeSelectedEvent,
} from "helpers/services/mixpanel/events";

export function useSearchModeSelectorEvents() {
  const trackSearchModeSelection = (searchMode: SearchMode) => {
    const eventData: NewSearchModeSelectedEvent = {
      event: MixpanelEvent.NewSearchModeSelected,
      actionSource: MixpanelActionSource.SearchModeSelector,
      searchMode,
      version: getMajorVersion(),
    };

    trackEventServerSide(eventData);
  };

  return {
    trackSearchModeSelection,
  };
}
